// extracted by mini-css-extract-plugin
export default {"popover":"global_popover__IoIMb"};